import React, { useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import Appointment from '../../components/Appointment';
import Calendar from '../../components/Calendar';
import WithHeader from '../../components/SearchAndAddPatientsHeader/WithHeader';
import AppointmentFilter from '../../components/Header/AppointmentFilter';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointments } from '../../redux/Appointment/AppointmentAction';
import { setDate, setWeek } from '../../redux/Appointment/AppointmentAction';
import moment from 'moment-jalaali';

const CalenderOrAppointment = () => {
    const week = useSelector((state) => state.appointment.date?.week);
    const clinicId = useSelector((state) => state.user.workspace?.clinic?.id);
    const selectedDate = useSelector((state) => state.appointment.date?.selected);
    const today = moment(new Date()).format('YYYY-MM-DD');
    const { clinicId: params } = useParams();

    const dispatch = useDispatch();
    useEffect(() => {
        handleGetAppointment();
    }, [clinicId, week]);

    function handleGetAppointment() {
        const dateParam = {
            to: week[6],
            from: week[0]
        };

        if (week[0] && clinicId) {
            dispatch(getAppointments(clinicId, dateParam));
        }
    }

    useEffect(() => {
        if (selectedDate) {
            if (week && !week.includes(selectedDate)) {
                dispatch(setWeek(selectedDate));
            }
        } else {
            dispatch(setDate(today));
            dispatch(setWeek(today));
        }
    }, [selectedDate]);

    return (
        <>
            <Switch>
                <Route path={`/${params}/appointment/day`} component={Appointment} />
                <Route path={`/${params}/appointment/week`} component={Calendar} />
            </Switch>
        </>
    );
};

export default WithHeader(CalenderOrAppointment, AppointmentFilter);
